import { initPayment } from '@/apis/payment';
import { InitPaymentResponseWrapper, PaymentInfo } from '@/types/Payment/InitPayment';
import { createSlice } from '@reduxjs/toolkit';

const initialState: InitPaymentResponseWrapper<PaymentInfo> = {
  data: {
    transactionNo: '',
    paymentUrl: '',
  },
  loading: false,
  errors: [],
  succeeded: false,
  message: '',
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    resetPaymentState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(initPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(initPayment.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetPaymentState } = paymentSlice.actions;

export default paymentSlice.reducer;
